module.exports = __webpack_public_path__ + "static/media/calender_nav.735d3fe0.svg";